import script from "./App.vue?vue&type=script&setup=true&name=App&lang=js"
export * from "./App.vue?vue&type=script&setup=true&name=App&lang=js"

import "./App.vue?vue&type=style&index=0&id=888c2dfc&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-888c2dfc"]])

export default __exports__